export const intitalState = {
  resume: false,
  details: false,
  skills: false,
  projects: false,
};
